import React from "react";
import MenuFarolDeskMobile from "../../../components/gestao/MenuFarol/MenuDeskMobile";
import { Grid } from "@mui/material";
import { defaultRequest } from "../../../utils/functions";
import "react-datepicker/dist/react-datepicker.css";
import { useState, useEffect } from "react";
import "../Acessos/acessos.css";
import Row from "./RowAtualizacoes";

export default function Atualizacoes() {
    const [dados, setDados] = useState(false);
    const route = "/atualizacoes";

    useEffect(() => {
        defaultRequest(route, {}).then(function (response) { setDados(response); }).catch((error) => { console.log("Error:", error.message); return; });
    }, []);

    return (
        <>
            <MenuFarolDeskMobile
                title={''}
                body={
                    <div className="card-total">
                        <div className="divider-pacote" />
                        {dados && (<>
                            <Grid container className="" >
                                <table>
                                    <thead>
                                        <tr className="header-tabela">

                                            {Object.keys(dados[0]).map((iten) => { return <th className="th" >{iten}</th> })}

                                        </tr>
                                    </thead>
                                    <tbody> {dados && dados.map((iten) => { return <Row row={iten} />; })}
                                    </tbody>
                                </table>

                            </Grid>

                        </>)}

                    </div >
                }
            />
        </>
    );
}
